module.exports = __webpack_public_path__ + "static/media/spritzer-logo.425a5098.png";